import React, { useState, useEffect, useMemo, useRef, startTransition } from 'react';
import axios from 'axios';
import './SalesDetailsPage.css';
import RecordsLoader from './component/RecordsLoader';
import { jsPDF } from "jspdf";
import UpdatePaymentModal from './component/UpdatePaymentModal';
import styles from './component/emailpreview.module.css';
import { ToastContainer, toast, cssTransition } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { maskMobileNumber, maskEmail} from './utilities/maskfunction';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt} from "@fortawesome/free-solid-svg-icons";
// import {exportToExcel} from './src/exportToExcel';
import { exportToExcel } from '../src/utilities/exportToExcel.js';
import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import UpdateRefundModal from './component/UpdateRefundModal.js';
import { drawerClasses } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import socket from './socket';
import { formatDate } from './utilities/formatDate.js';

import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";

const userTypes = [
  'Select',
  'Thru Sales Guys',
  // 'Direct',
  // "All Medical Colleges",
  // 'Belle Vue Hospital Kolkata',
  // 'Mercury Hospital Chennai',
  'RF20',
  'RF10',
  // 'Brains Hospital Bangalore',
  // 'ZYDUS Hospital',
  'GANGARAM',
  'Medical College',
  'MERCURY A',
  'MERCURY B'

];


const convertToBase64 = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // This is crucial for CORS
    img.src = url;
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL('image/png');
      resolve(dataURL);
    };
    img.onerror = (error) => reject(error);
  });
};

export const generateTRFDocument = async (entry) => {
  // console.log("generateTRF Entry",entry)
  const doc = new jsPDF('p', 'mm', 'a4'); //potrait,dimension in mm and size A4

  // Define initial position and dimensions
  let startX = 10;
  let startY = 15;
  const lineHeight = 4;
  const boxHeight = lineHeight * 1.6;
  const boxWidth = 190;
  const halfBoxWidth = (boxWidth / 2) - 5;
  const textPadding = 5;
  const maxY=280;

  const logoUrl = 'https://crm-zeniximages.s3.ap-south-1.amazonaws.com/amrita.png';

  try {
    const logoBase64 = await convertToBase64(logoUrl);
 
    doc.addImage(logoBase64, 'PNG', 175, 5, 28, 28); // Position at (175, 5), size (28x28)
  } catch (error) {
    console.error('Failed to load image:', error);
    // Handle the error appropriately (e.g., display a placeholder image, or skip adding the image)
  }

// Use the jsPDF 'addImage' method to add the logo
// doc.addImage(logoUrl, 'PNG', 175, 5, 28, 28); // Position at (160, 10), size (30x30). Adjust as needed.


  // Add title and subtitle
  doc.setFontSize(14);
  doc.setFont('helvetica', 'bold');
  doc.text("ZeiniX AIN TRF", startX, startY, null, null);

  startY += lineHeight + 2;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.text("Test Request Form For Ordering Autoimmune Neurology Diagnostics", startX, startY, null, null);
  startY += lineHeight + 5;

  // Add institution and notes
  doc.setFontSize(9);
  doc.setFont('helvetica', 'italic');
  doc.text("Sample Sent Through ZeiniX Life Sciences", startX, startY);
  doc.text("Tested At: Nalanda 7th Floor, Amrita Institute of Medical Sciences & Research Centre (AIMS), Kochi, Kerala, India", startX, startY + lineHeight);
  startY += lineHeight * 2.5;

  doc.setFont('helvetica', 'bold');
  doc.text("* Important", startX, startY);
  startY += lineHeight * 0.8;
  doc.setFont('helvetica', 'normal');
//  drawBox( doc.text("Please enter patient name exactly as needed in the report / invoice. Once submitted, name cannot be changed.", startX, startY + lineHeight);
//   doc.text("Please ensure the name in this TRF & sample tube are exactly same - otherwise sample will get rejected.", startX, startY + (lineHeight * 2));
 
//  );

// Define the text for the important message
const importantText1 = "Please enter patient name exactly as needed in the report / invoice. Once submitted, name cannot be changed.";
const importantText2 = "Please ensure the name in this TRF & sample tube are exactly same - otherwise sample will get rejected.";
const importantText = importantText1 + "\n" + importantText2;
// Calculate the box height based on the number of lines
const importantLines = doc.splitTextToSize(importantText, boxWidth - (textPadding * 1));
const importantBoxHeight = (importantLines.length * lineHeight) + (textPadding * 1);
doc.setFont('helvetica', 'normal');
drawBox(doc, startX, startY, boxWidth, importantBoxHeight, importantText);

startY += importantBoxHeight + 4; // Move startY down for the next section

doc.setFont('helvetica', 'bold');
  doc.setFontSize(8);
  doc.text("AIMS Form Control Number FO-NEIM-001", startX, startY);
  startY += lineHeight + 5;

  // Patient Information
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text("Patient Information", startX, startY);
  startY += lineHeight;
  doc.setFontSize(8);
  // doc.setFont('helvetica', 'normal');
  drawBox(doc, startX, startY, boxWidth, boxHeight, `Patient Name: ${entry.PatientFullName || 'N/A'}`);
  startY += boxHeight + 4;
  
  drawBox(doc, startX, startY, halfBoxWidth, boxHeight, `Patient Age: ${entry.PatientAge || 'N/A'}`);
  drawBox(doc, startX + halfBoxWidth + 10, startY, halfBoxWidth, boxHeight, `Patient Date of Birth: ${entry.PatientDateOfBirth&&(entry.PatientDateOfBirth!=="Invalid date")?entry.PatientDateOfBirth : 'N/A'}`);
  startY += boxHeight + 4;

  drawBox(doc, startX, startY, halfBoxWidth, boxHeight, `Patient Mobile: ${entry.PatientMobileNumber || 'N/A'}`);
  drawBox(doc, startX + halfBoxWidth + 10, startY, halfBoxWidth, boxHeight, `Patient Email: ${entry.PatientEmailID || 'N/A'}`);
  startY += boxHeight + 4;
  drawBox(doc, startX, startY, halfBoxWidth, boxHeight, `Patient Gender: ${entry.PatientGender || 'N/A'}`);
  startY += boxHeight + 8;

  // Physician Information
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text("Physician Information", startX, startY);
  startY += lineHeight;
  doc.setFontSize(8);
  drawBox(doc, startX, startY, halfBoxWidth, boxHeight, `Primary Physician: ${entry.ReferringConsultantName_PrimaryPhysician || 'N/A'}`);
  drawBox(doc, startX + halfBoxWidth + 10, startY, halfBoxWidth, boxHeight, `Hospital ID: ${entry.PatientHospitalID || 'N/A'}`);
  startY += boxHeight + 4;

  drawBox(doc, startX, startY, halfBoxWidth, boxHeight, `Primary Physician Mob No.: ${maskMobileNumber(entry.PrimaryPhysicianMobileNumber)}`);
  drawBox(doc, startX + halfBoxWidth + 10, startY, halfBoxWidth, boxHeight, `Primary Physician Email: ${entry.PrimaryPhysicianEmailId || 'N/A'}`);
  startY += boxHeight + 4;

  drawBox(doc, startX, startY, halfBoxWidth, boxHeight, `Alternate Physician: ${(entry.ReferringDoctorName_AlternatePhysician && entry.ReferringDoctorName_AlternatePhysician!=="Dr.")?entry.ReferringDoctorName_AlternatePhysician: 'N/A'}`);
  drawBox(doc, startX + halfBoxWidth + 10, startY, halfBoxWidth, boxHeight, `Alternate Physician Mob No.: ${entry.AlternatePhysicianMob || 'N/A'}`);
  startY += boxHeight + 4;

  drawBox(doc, startX, startY, halfBoxWidth, boxHeight, `Alternate Physician Email: ${entry.AlternativePhysicianEmailId || 'N/A'}`);
  drawBox(doc, startX + halfBoxWidth + 10, startY, halfBoxWidth, boxHeight, `Hospital / Clinic: ${entry.HospitalClinicName || 'N/A'}`);
  startY += boxHeight + 4;

  drawBox(doc, startX, startY, halfBoxWidth, boxHeight, `Hospital Email: ${entry.HospitalorClinicalEmailId || 'N/A'}`);
  drawBox(doc, startX + halfBoxWidth + 10, startY, halfBoxWidth, boxHeight, `City: ${entry.City || 'N/A'}`);
  startY += boxHeight + 9;

  // Clinical Details
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text("Clinical Details / Provisional Diagnosis", startX, startY);
  startY += lineHeight;
  doc.setFontSize(8);
  drawBox(doc, startX, startY, boxWidth, boxHeight * 1.5, `${entry.ClinicalDetailsofPatient|| 'N/A'}`);
  startY += boxHeight * 2 + 5;

  // Sample Details
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.text("Sample Details", startX, startY);
  startY += lineHeight;
  doc.setFontSize(8);
  drawBox(doc, startX, startY, halfBoxWidth, boxHeight, `Sample Sent: ${entry.SampleSent || 'N/A'}`);
  drawBox(doc, startX + halfBoxWidth + 10, startY, halfBoxWidth, boxHeight, `No. of Samples: ${entry.NoOfSampleSent || 'N/A'}`);
  startY += boxHeight + 4;

 

  drawBox(doc, startX, startY, halfBoxWidth, boxHeight, `No. of Tests: ${entry.tests.length || 'N/A'}`);
  startY += boxHeight + 4;
  // const testsArray = Array.isArray(entry.tests) ? entry.tests : [];
  const testsArray=entry.tests;
  // console.log("testsArray",entry.tests)
  // const validTests = testsArray.filter(test => test !== undefined && test !== null);
  
  testsArray.forEach((test, index) => {
    // Combine test name and sample information into a single string
    const testInfo = `Test ${index + 1}: ${testsArray[index].test || 'N/A'}, Sample: ${testsArray[index].sample || 'N/A'}`;
    // Check if content exceeds the current page height
  if (startY + boxHeight > maxY) {
    doc.addPage(); // Add a new page
    
    startY = 15;   // Reset the Y position for the new page (adjust as per your layout)
  }
  
    // Draw the combined information in a single box
    drawBox(doc, startX, startY, boxWidth, boxHeight, testInfo);
  
    // Update startY for the next test
    startY += boxHeight + 3; // Adjust space between boxes as needed
  });

  // Footer Information
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  startY += boxHeight -3;
  drawBox(doc,startX, startY, halfBoxWidth, boxHeight,`Sample Collection Date: ${entry.SampleCollectionDate ||'N/A'}`)
  
  drawBox(doc,startX + halfBoxWidth + 10, startY, halfBoxWidth, boxHeight,`Sample Collection Time: ${entry.SampleCollectionTime||'N/A'}`) 
  // doc.text("Sample Collection Date: 03-04-2024 Sample Collection Time: 12:00:00", startX, startY);
  startY += lineHeight;
  doc.setFont('helvetica', 'normal');
  startY += boxHeight ;
  // doc.rect(startX, startY, boxWidth, boxHeight)
  // doc.text("Form Filled By: Referring Dr / Alternate Physician Form Filled By: Dr Thomas Mathew", startX, startY);
  drawBox(doc,startX, startY, halfBoxWidth, boxHeight,`Form Filled By: ${entry.FormFilledBy||'N/A'}`) 
  drawBox(doc,startX + halfBoxWidth+10, startY, halfBoxWidth, boxHeight,`Form Filled Person Name: ${entry.FormFilledBy_Name||'N/A'}`) 
 startY += boxHeight
  drawBox(doc,startX,startY+5,boxWidth,boxHeight+8,`I hereby grant my informed consent to ZeiniX Life Sciences Pvt. Ltd., Bangalore, to facilitate the diagnostic testing of the biological sample of patient ${entry.PatientFullName} at Amrita Institute of Medical Sciences, Cochin, for the purpose of medical evaluation.`)
  const today = new Date();
  const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;



  // Save the document
  doc.save(`${entry.PatientFullName ||entry.HospitalName||"Zeinix"}_TRF_${formattedDate}.pdf`);
};

// Helper function to draw boxed text areas
const drawBox = (doc, x, y, width, height, text) => {
  doc.setLineWidth(0.2);
  doc.rect(x, y, width, height);
  const lines = doc.splitTextToSize(text, width - 4);
  doc.text(lines, x + 2, y + 5);
};




// Re-renders only when `deps` change, so existing rows are skipped when more rows are appended.
const MemoRow = React.memo(
  ({ render }) => render(),
  (prev, next) => prev.deps.length === next.deps.length && prev.deps.every((d, i) => Object.is(d, next.deps[i]))
);

const SalesDetailsPage = () => {
  const [salesEntries, setSalesEntries] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);

  const [selectedEntryForEmail, setSelectedEntryForEmail] = useState(null);
  const [selectedEntryForPayment, setSelectedEntryForPayment] = useState(null);
  const [editableEntryId, setEditableEntryId] = useState(null);
  const [savingEntryId, setSavingEntryId] = useState(null);
  const [emailHTML, setEmailHTML] = useState('');
  const [loading, setLoading] = useState(false);
  const [isInvoiceModalOpen, setIsInvoiceModalOpen] = useState(false);
  const [isBillingCodeModalOpen, setIsBillingCodeModalOpen] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);

  const [userType, setUserType] = useState('');
  const [selectedEntryId, setSelectedEntryId] = useState(null);
  const userRole=localStorage.getItem('role');

const [amount, setAmount] = useState(0);
const [discount, setDiscount] = useState(0);
const [additionalCharge, setAdditionalCharge] = useState(0);
const [finalAmount, setFinalAmount] = useState(0);
const [billingAmounts, setBillingAmounts] = useState({});
const [billingAmountsLoading, setBillingAmountsLoading] = useState(false);
  const currentUserId = (() => {
    try {
      const token = localStorage.getItem('token');
      if (!token) return null;
      const payload = JSON.parse(atob(token.split('.')[1]));
      return payload.id ?? payload.userId ?? payload.UserID ?? null;
    } catch { return null; }
  })();
  const canSeeDates = [5, 51, 53].includes(Number(currentUserId));
  const [testlist, settestlist]=useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  // allLoaded: every record is in `salesEntries`, so paging/page size/search run locally.
  const [allLoaded, setAllLoaded] = useState(false);
  const [prefetchTick, setPrefetchTick] = useState(0);
  const dataVersionRef = useRef(0);
  const [isDeleteModalOpen, setIsDeleteModalOpen]=useState(false);
  const [openKebabId, setOpenKebabId] = useState(null);
  const [kebabPos, setKebabPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!openKebabId) return;
    const close = () => setOpenKebabId(null);
    document.addEventListener('click', close);
    document.addEventListener('scroll', close, true); // capture phase catches table body scroll too
    return () => {
      document.removeEventListener('click', close);
      document.removeEventListener('scroll', close, true);
    };
  }, [openKebabId]);
  const [SelectedEntryForRefund,setSelectedEntryForRefund]=useState(null)

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState("50");    // choose your page size
  const [totalPages, setTotalPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState(""); 
  const [fromDate, setFromDate] = useState("");
  const [salesAccessMinDate, setSalesAccessMinDate] = useState("");
  const [salesPersons, setSalesPersons] = useState([]);

  // Main function to fetch paginated sales data
const fetchSalesEntries = async (opts = {}) => {
  try {
    setLoading(true);
    setError("");

    const nextPage = opts.page ?? page;
    const nextLimit = opts.limit ?? limit;
    const nextFromDate = opts.fromDate ?? fromDate;
   

    const token = localStorage.getItem("token");

    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/sales`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
        params: {
          page: nextPage,
          limit: nextLimit,
          ...(nextFromDate ? { fromDate: nextFromDate } : {}),
          t: Date.now(), // dev cache-buster
        },
        validateStatus: () => true, // let us see non-2xx for debugging
      }
    );

    if (response.status === 401 && response.data?.logout === true) {
  localStorage.removeItem('token');
  window.location.href = '/login';
  return;
}

  
  
    let payload = response.data;
    // console.log("payload",payload)

   

  if (payload && Array.isArray(payload.data)) {
  // prefer nested pagination first
  const p = payload.pagination || {};
  // fall back to top-level if needed
  const total = p.total ?? payload.total ?? payload.data.length ?? 0;
  // console.log("total",total)
  const srvPage = p.page ?? payload.page ?? 1;
  const srvLimit = p.limit ?? payload.limit ?? 100;

 
  const srvPages = p.pages ?? payload.pages ?? Math.max(1, Math.ceil(total / srvLimit));
  // console.log("srvPage",srvPage,srvLimit,srvPages)

  dataVersionRef.current += 1;
  setAllLoaded(false);
  setSalesEntries(payload.data);
  setTotal(Number(total) || 0);
  setPage(Number(srvPage) || 1);
  setLimit(String(srvLimit) || 100);
  setTotalPages(Math.max(1, Number(srvPages) || 1));
  return;
}
  } catch (err) {
    console.error("Failed to fetch sales entries:", err);
    setError("Failed to fetch sales entries");
  } finally {
    setLoading(false);
  }
};
//  useEffect(() => {
//   if (userRole === "admin") {
//     const loadFromCache = () => {
//       const cachedData = sessionStorage.getItem("salesData");
//       if (cachedData) {
//         setLoading(true);
//         const parsedData = JSON.parse(cachedData);
//         setSalesEntries(parsedData);
//         console.log("Loaded sales data from sessionStorage");
//           // Give UI time to render loader before hiding it
//         setTimeout(() => {
//           setLoading(false);
//         }, 50);
//         return true;
//       }
//       setLoading(false);
//       return false;
//     };

    

//    const fetchSalesEntries = async (opts = {}) => {
//   try {
//     setLoading(true);
//     setError("");

//     const nextPage = opts.page ?? page;
//     const nextLimit = opts.limit ?? limit;
//     const nextFromDate = opts.fromDate ?? fromDate;

//     const token = localStorage.getItem("token");
//     if (!token) {
//       setError("No auth token found");
//       return;
//     }

//     const response = await axios.get(
//       `${process.env.REACT_APP_API_BASE_URL}/api/sales`, // or /api/sales/dashboard if that's your route
//       {
//         headers: { Authorization: `Bearer ${token}` },
//         params: {
//           page: nextPage,
//           limit: nextLimit,
//           ...(nextFromDate ? { fromDate: nextFromDate } : {}),
//           t: Date.now(), // cache-bust to avoid 304 in dev
//         },
//       }
//     );

//     const payload = response.data;

//     if (Array.isArray(payload)) {
//       // Backend not paginated yet — handle array
//       const sorted = payload.sort((a, b) => b.id - a.id);
//       setSalesEntries(sorted);
//       setTotal(sorted.length);
//       setTotalPages(1);
//       setPage(1);
//     } else {
//       // Expected paginated shape: { data, total, page, limit, totalPages }
//       const {
//         data = [],
//         total = 0,
//         page: srvPage = nextPage,
//         limit: srvLimit = nextLimit,
//         totalPages: srvPages = 1,
//       } = payload;

//       setSalesEntries(data);
//       setTotal(total);
//       setTotalPages(Math.max(1, srvPages));
//       setPage(srvPage);
//       setLimit(srvLimit);
//     }

//     console.log("Fetched sales data (page):", nextPage);
//   } catch (err) {
//     console.error("Failed to fetch sales entries:", err);
//     setError("Failed to fetch sales entries");
//   } finally {
//     setLoading(false);
//   }
// };

//     // 1. Load cache or fetch from API on mount
//     if (!loadFromCache()) {
//       fetchSalesEntries();
//     }

//     // 2. Listen for updates from Socket.IO
//     socket.on("salesUpdated", () => {
//       console.log("🔄 Sales updated event received from Backend refetching the sales Entry");
//       fetchSalesEntries(); // Refresh data & cache
//     });

//     // 3. Cleanup on unmount
//     return () => {
//       socket.off("salesUpdated");
//     };
//   }
// }, []);

useEffect(() => {
  const initLoad = async () => {
    if (userRole === 'sales_rep') {
      try {
        const token = localStorage.getItem('token');
        const currentUsername = localStorage.getItem('username');
        const res = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/config/sales-access`,
          { headers: { Authorization: `Bearer ${token}` }, params: { username: currentUsername } }
        );
        const minDate = res.data?.salesDataFromDate || '';
        if (minDate) {
          setSalesAccessMinDate(minDate);
          setFromDate(minDate);
        }
      } catch (e) {
        console.error('Failed to fetch sales access config:', e);
      }
    }
    fetchSalesEntries({ page: 1 });
  };
  initLoad();
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);
  const regionalCodesfromlocal = JSON.parse(localStorage.getItem('regionalCodes') || '[]');
  useEffect(()=>{

    const fetchtestlist=async()=>{
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/testlist`
      );
      settestlist(response.data);
      // console.log("testlist", response.data);
    } catch (error) {
      console.error("Failed to fetch Testlist:", error);
      toast.error("Failed to fetch Testlist");
    }
  //  else {
  //   settestlist([]);
  // }

}
fetchtestlist();
  },[]);

  useEffect(() => {
    const fetchSalesPersons = async () => {
     
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/api/users/users-with-regions`,
          { headers: { 'Authorization': `Bearer ${token}` } }
        );
        
        const activeUsers = (Array.isArray(response.data) ? response.data : [])
          .filter(u => u.isActive);
        setSalesPersons(activeUsers);
          // console.log("salesperson response",response)
      } catch (error) {
        console.error('Failed to fetch sales persons:', error);
      }
    };
    fetchSalesPersons();
  }, []);

  // console.log("salesEntriesbeforefilter:", salesEntries);
  // console.log("Type:", typeof salesEntries);
// console.log("Is Array:", Array.isArray(salesEntries));
  const filteredData = useMemo(() => (Array.isArray(salesEntries) ? salesEntries : []).filter((item) => {
    const rowText = `${item.id}${item.PatientFullName} ${item.PatientMobileNumber} ${item.PatientAddress} ${item.PatientEmailID}${item.ReferringConsultantName_PrimaryPhysician
} ${item.HospitalClinicName} `.toUpperCase();
    if (!rowText.includes(searchQuery.toUpperCase())) return false;
    const effectiveMinDate = fromDate || salesAccessMinDate;
    if (effectiveMinDate && item.createdAt) {
      const itemDate = item.createdAt.slice(0, 10);
      if (itemDate < effectiveMinDate) return false;
    }
    return true;
  }).sort((a, b) => b.id - a.id), [salesEntries, searchQuery, fromDate, salesAccessMinDate]);

  // Once everything is loaded the page is cut locally; before that the server page is shown as-is.
  const everythingLoaded = allLoaded || (total > 0 && salesEntries.length >= total);
  const pageSizeNum = limit === 'unlimited' ? Infinity : (Number(limit) || 50);
  const displayTotal = everythingLoaded ? filteredData.length : total;
  const displayTotalPages = everythingLoaded
    ? (pageSizeNum === Infinity ? 1 : Math.max(1, Math.ceil(filteredData.length / pageSizeNum)))
    : totalPages;
  const displayPage = everythingLoaded ? Math.min(page, displayTotalPages) : page;
  const pageData = useMemo(() => {
    if (!everythingLoaded || pageSizeNum === Infinity) return filteredData;
    const start = (displayPage - 1) * pageSizeNum;
    return filteredData.slice(start, start + pageSizeNum);
  }, [filteredData, everythingLoaded, pageSizeNum, displayPage]);

  useEffect(() => {
    if (everythingLoaded) setPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  // Pages of up to 500 rows render fully; larger ones ("All") render in chunks as you scroll.
  const ROW_CHUNK = 300;
  const CHUNK_THRESHOLD = 500;
  const [visibleCount, setVisibleCount] = useState(ROW_CHUNK);
  const sentinelRef = useRef(null);
  const chunkingActive = pageData.length > CHUNK_THRESHOLD;
  const renderedData = useMemo(
    () => (chunkingActive ? pageData.slice(0, visibleCount) : pageData),
    [chunkingActive, pageData, visibleCount]
  );
  const hasMoreRows = chunkingActive && visibleCount < pageData.length;
  // Loading the next chunk starts when the user reaches this row (half a chunk before the end).
  const triggerIndex = Math.max(0, renderedData.length - Math.floor(ROW_CHUNK / 2));
  useEffect(() => {
    setVisibleCount(ROW_CHUNK);
  }, [searchQuery, fromDate, page, limit]);

  useEffect(() => {
    const node = sentinelRef.current;
    if (!node || !hasMoreRows) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) setVisibleCount((c) => c + ROW_CHUNK);
      },
      { rootMargin: '1000px' }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [hasMoreRows, visibleCount]);

  // Auto table layout re-measures every row on each append; freezing measured column widths avoids that.
  const tableRef = useRef(null);
  const [colWidths, setColWidths] = useState(null);
  useEffect(() => {
    setColWidths(null);
  }, [limit, fromDate]);
  useEffect(() => {
    if (colWidths || loading || !tableRef.current || renderedData.length === 0) return;
    const ths = tableRef.current.querySelectorAll('thead th');
    setColWidths(Array.from(ths, (th) => th.getBoundingClientRect().width));
  }, [colWidths, loading, renderedData.length]);
  const useFixedLayout = !!colWidths && editableEntryId === null;

  const fetchSalesEntriesbyregionalID = async (opts = {}) => {
    try {
      setLoading(true);
      setError('');
      const nextPage = opts.page ?? page;
      const nextLimit = opts.limit ?? limit;
      const nextFromDate = opts.fromDate ?? fromDate;
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/sales/${regionalCodesfromlocal}`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        params: {
          page: nextPage,
          limit: nextLimit,
          ...(nextFromDate ? { fromDate: nextFromDate } : {}),
          t: Date.now(),
        },
      });
      const payload = response.data;
      if (payload && Array.isArray(payload.data)) {
        const p = payload.pagination || {};
        const total = p.total ?? payload.total ?? payload.data.length ?? 0;
        const srvPage = p.page ?? payload.page ?? nextPage;
        const srvLimit = p.limit ?? payload.limit ?? nextLimit;
        const srvPages = p.pages ?? payload.pages ?? Math.max(1, Math.ceil(total / srvLimit));
        dataVersionRef.current += 1;
        setAllLoaded(false);
        setSalesEntries(payload.data);
        setTotal(Number(total) || 0);
        setPage(Number(srvPage) || 1);
        setLimit(String(srvLimit));
        setTotalPages(Math.max(1, Number(srvPages) || 1));
      } else if (Array.isArray(payload)) {
        const sorted = payload.sort((a, b) => b.id - a.id);
        dataVersionRef.current += 1;
        setAllLoaded(false);
        setSalesEntries(sorted);
        setTotal(sorted.length);
        setPage(1);
        setTotalPages(1);
      }
      // console.log('Response', response);
    } catch (error) {
      console.error('Failed to fetch sales entries:', error);
      setError('Failed to fetch sales entries');
    } finally {
      setLoading(false);
    }
  };

  const fetchData = (opts = {}) => {
    if (userRole !== 'admin' && userRole !== 'Super_Admin') {
      fetchSalesEntriesbyregionalID(opts);
    } else {
      fetchSalesEntries(opts);
    }
  };

  // After the first page, download every record in the background; from then on paging,
  // page size and search are handled locally with no further server calls.
  const prefetchingRef = useRef(false);

  const prefetchAllEntries = async () => {
    prefetchingRef.current = true;
    const version = dataVersionRef.current;
    try {
      const base = process.env.REACT_APP_API_BASE_URL;
      const isAdminRole = userRole === 'admin' || userRole === 'Super_Admin';
      const url = isAdminRole ? `${base}/api/sales` : `${base}/api/sales/${regionalCodesfromlocal}`;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        params: { page: 1, limit: 'unlimited', ...(fromDate ? { fromDate } : {}), t: Date.now() },
      });
      const rows = res.data && Array.isArray(res.data.data) ? res.data.data : null;
      if (version !== dataVersionRef.current) {
        // A newer server fetch replaced the data while this was in flight; start over.
        setPrefetchTick((t) => t + 1);
        return;
      }
      if (rows) {
        startTransition(() => {
          // Rows already on screen may carry newer edits than the downloaded copy.
          setSalesEntries((prev) => {
            const local = new Map(prev.map((e) => [e.id, e]));
            return rows.map((e) => local.get(e.id) || e);
          });
          setTotal(rows.length);
          setAllLoaded(true);
        });
      }
    } catch (err) {
      console.error('Background load of all sales entries failed:', err);
    } finally {
      prefetchingRef.current = false;
    }
  };

  useEffect(() => {
    if (loading || allLoaded || prefetchingRef.current) return;
    if (!(total > salesEntries.length)) return;
    prefetchAllEntries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, allLoaded, total, prefetchTick]);

  const goToPage = (nextPage) => {
    if (everythingLoaded) setPage(nextPage);
    else fetchData({ page: nextPage });
  };

  const handlePageSizeChange = (newLimit) => {
    setLimit(newLimit);
    if (everythingLoaded) {
      setPage(1);
      return;
    }
    fetchData({ page: 1, limit: newLimit });
  };

  useEffect(() => {
    if (userRole !== 'admin' && userRole !== 'Super_Admin') {
      fetchSalesEntriesbyregionalID({ page: 1 });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRefundModalOpen]);

  useEffect(() => {
  const final =
    Number(amount) -
    Number(discount || 0) +
    Number(additionalCharge || 0);

  setFinalAmount(final);
}, [amount, discount, additionalCharge]);

const handleUserTypeChange = (e) => {
  const selectedType = e.target.value;
  setUserType(selectedType);
  setAmount(billingAmounts[selectedType] ?? 0);
};

const fetchBillingAmounts = async (entryId) => {
  try {
    setBillingAmountsLoading(true);
    const response = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/sales/totalSalesAmount/${entryId}`
    );
    setBillingAmounts(response.data || {});
  } catch (err) {
    console.error('Failed to fetch billing amounts:', err);
    toast.error('Failed to fetch billing amounts for this entry');
    setBillingAmounts({});
  } finally {
    setBillingAmountsLoading(false);
  }
};

  const handleOpenModal = (entry) => {
    // console.log("sendemail1",entry)
    // console.log("selectedEntryForEmail",)
    setSelectedEntryForEmail(entry);
    fetchEmailPreview(entry);
    
  
    setIsModalOpen(true);
  };
  const handleInvoiceModal=(entry)=>{
    setSelectedEntryId(entry.id);
    setSelectedEntry(entry);
    // console.log("entry for invoice",entry)

    setIsInvoiceModalOpen(true);
  }

   const handleBillingCodeModal=(entry)=>{
    setSelectedEntryId(entry.id);
    setSelectedEntry(entry);

    const existingBillingCode = entry.metadata?.billingCode;
    if (existingBillingCode) {
      setUserType(existingBillingCode.salesType || '');
      setAmount(existingBillingCode.amount ?? 0);
      setDiscount(existingBillingCode.discount ?? 0);
      setAdditionalCharge(existingBillingCode.additionalCharge ?? 0);
    } else {
      setUserType('');
      setAmount(0);
      setDiscount(0);
      setAdditionalCharge(0);
    }
    setBillingAmounts({});

    setIsBillingCodeModalOpen(true);
    fetchBillingAmounts(entry.id);
  }
  const handleDeleteModal=(entry)=>{
    setSelectedEntryId(entry.id);
    setSelectedEntry(entry);
    // console.log("entry for delete modal",entry)

    setIsDeleteModalOpen(true);
  }

  const fetchEmailPreview = async (entry) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/sales/sendEmailPreview`, entry);
      setEmailHTML(response.data.html);
    } catch (error) {
      console.error('Failed to fetch email preview:', error);
      setEmailHTML('<p>Failed to load email preview.</p>');
    }
  };

  const sendEmail = async () => {
    try {

      setLoading(true);
      // send email URL
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/sales/sendEmail`, selectedEntryForEmail);
      // console.log("selectedEntryForEmail", selectedEntryForEmail);
      alert('Email sent successfully!');
      setIsModalOpen(false); // Close the modal
    } catch (error) {
      alert('Failed to send email.');
      console.error('Failed to send email:', error);
    }
    setLoading(false);
  };


  const handleGenerateBillingCode = async () => {
  try {
    setLoading(true);

    const calculatedFinalAmount =
      Number(amount) - Number(discount || 0) + Number(additionalCharge || 0);
    const payload = {
      salesType: userType,
      amount,
      discount,
      additionalCharge,
      finalAmount: calculatedFinalAmount,
    };

    await axios.patch(`${process.env.REACT_APP_API_BASE_URL}/api/sales/metadata/${selectedEntryId}/billing-code`,
      payload
    );

    setSalesEntries((prevEntries) =>
      prevEntries.map((entry) =>
        entry.id === selectedEntryId
          ? {
              ...entry,
              Amount: calculatedFinalAmount,
              PaymentAmount: calculatedFinalAmount,
              metadata: {
                ...(entry.metadata || {}),
                billingCode: {
                  ...(entry.metadata?.billingCode || {}),
                  ...payload,
                },
              },
            }
          : entry
      )
    );

    if (!everythingLoaded) await fetchData({ page, limit, fromDate });

    toast.success('Billing code applied successfully');
    setIsBillingCodeModalOpen(false);
  } catch (err) {
    console.error(err);
    toast.error('Failed to apply billing code');
  } finally {
    setLoading(false);
  }
};

  const handleOpenPaymentModal = (entry) => {
    setSelectedEntryForPayment(entry);
    setIsPaymentModalOpen(true);
  };
  const handleOpenRefundModal = (entry) => {
    setSelectedEntryForRefund(entry);
    setIsRefundModalOpen(true);
  };

const updatePaymentDetails = (id, paymentMode, paymentStatus, paymentDate, receivedAmount) => {
  setSalesEntries((prevEntries) => {
    const updatedEntries = prevEntries.map((entry) =>
      entry.id === id
        ? { 
            ...entry, 
            PaymentMethod: paymentMode,
            PaymentStatus: paymentStatus, 
            PaymentDate: paymentDate, 
            PaymentAmount: receivedAmount 
          }
        : entry
    );
    const first500Entries = updatedEntries.slice(0, 500);
    // sessionStorage.setItem("salesEntries", JSON.stringify(first500Entries)); // Keep session storage updated
    return updatedEntries;
  });
};

  const updateRefundDetails = (id, RefundAmount, RefundTransactionID, RefundDate) => {
    setSalesEntries((prevEntries) =>
      prevEntries.map((entry) =>
        entry.id === id
          ? { ...entry, RefundAmount: RefundAmount, RefundTransactionID: RefundTransactionID, RefundDate: RefundDate }
          : entry
      )
    );
  };


  
  const formatTests = (tests) => {
    return tests.map(test => {
      let line = `<span style="font-weight:600">${test.test}</span> &nbsp;<span style="background:#e8f0fe;color:#1a56db;border-radius:4px;padding:1px 6px;font-size:11px">${test.sample}</span>`;
      if (canSeeDates && test.sampleReceivedDate) line += ` &nbsp;<span style="background:#dcfce7;color:#15803d;border-radius:4px;padding:1px 6px;font-size:11px">&#128197; Received: ${formatDate(test.sampleReceivedDate)}</span>`;
      if (canSeeDates && test.reportUploadedAt) line += ` &nbsp;<span style="background:#fef9c3;color:#854d0e;border-radius:4px;padding:1px 6px;font-size:11px">&#128196; Report Sent: ${formatDate(test.reportUploadedAt)}</span>`;
      return line;
    }).join('<br/>');
  };

  const canEditSalesEntry = ['admin', 'Super_Admin', 'sales_rep', 'regional_sales_head'].includes(userRole);

  const handleEdit = (id) => {
    setEditableEntryId(id);
  };




  const handleTestChange = (entryId, index, field, value) => {
    setSalesEntries((prevEntries) =>
      prevEntries.map((entry) =>
        entry.id === entryId
          ? {
              ...entry,
              tests: entry.tests.map((test, i) =>
                i === index ? { ...test, [field]: value } : test
              ),
            }
          : entry
      )
    );
  };
  // const handleTestsampletypeChange = (entryId, index, field, value) => {
  //   setSalesEntries((prevEntries) =>
  //     prevEntries.map((entry) =>
  //       entry.id === entryId
  //         ? {
  //             ...entry,
  //             tests: entry.tests.map((test, i) =>
  //               i === index ? { ...test, [field]: value } : test
  //             ),
  //           }
  //         : entry
  //     )
  //   );
  // };
  
  const handleAddTest = (entryId) => {
    setSalesEntries((prevEntries) =>
      prevEntries.map((entry) =>
        entry.id === entryId
          ? {
              ...entry,
              tests: [...entry.tests, { test: "", sample: "", salesEntryId: entryId }],
            }
          : entry
      )
    );
  };
  
  const handleRemoveTest = async(entryId,testId, index) => {
    // console.log("index",entryId,testId, index)

    setSalesEntries((prevEntries) =>
      prevEntries.map((entry) =>
        entry.id === entryId
          ? {
              ...entry,
              tests: entry.tests.filter((_, i) => i !== index),
            }
          : entry
      )
    );
    if(testId){
      const deleteTest=`${process.env.REACT_APP_API_BASE_URL}/api/lab/test/${testId}`
    try{
    await axios.delete(deleteTest,{
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });

    toast.success("Test is removed successfully from SalesEntry")

  }
  catch(error){
    // console.log("Failed to delete the test entry",error)
    toast.error("Failed to remove the test")

  }
}
else{
  toast.success("Test is removed successfully from SalesEntry which is not saved")
}

  };
  
  const handleSave = async (entry, transactionStatus) => {
    if (savingEntryId !== null) return;
    setSavingEntryId(entry.id);
    try {
      const { tests, ...entryData } = entry;
     
      entryData.TransactionStatus = transactionStatus;
      // console.log("entryData",entry)
  
        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/sales/${entry.id}`, entryData, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
  
      // Update tests
      for (const test of tests) {
        if (test.id) {
          // console.log("testid",test.id)
          await axios.put(`${process.env.REACT_APP_API_BASE_URL}/api/sales/tests/${test.id}`, test, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          });
        } else {
          await axios.post(
            `${process.env.REACT_APP_API_BASE_URL}/api/sales/tests`,
            {
              ...test,
              salesEntryId: entry.id,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
            }
          );
        }
      }
      setSalesEntries((prevEntries) =>
        prevEntries.map((prevEntry) =>
          prevEntry.id === entry.id
            ? { ...prevEntry, ...entryData }
            : prevEntry
        )
      );
  
      alert('Entry updated successfully!');
      setEditableEntryId(null); // Close edit mode
    } catch (error) {
      alert('Failed to update entry.');
      console.error('Failed to update entry:', error);
    } finally {
      setSavingEntryId(null);
    }
  };

  const handleGenerateInvoice = async (patientfullname) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/sales/generate-invoice/${selectedEntryId}`,
        {userType,},
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Accept': 'application/pdf', // Expect a PDF response
          },
          responseType: 'blob' // Set the response type to blob for binary data
        }
      );

      // Create a link to download the PDF
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      const today = new Date();
      const formattedDate = `${String(today.getDate()).padStart(2, '0')}-${String(today.getMonth() + 1).padStart(2, '0')}-${today.getFullYear()}`;
      
      link.setAttribute('download', `ZX_${selectedEntry.PatientFullName}_Invoice_${formattedDate}.pdf`);
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setIsModalOpen(false);
    } catch (error) {
      console.error('Error generating invoice:', error);
      let errorMessage = 'Failed to generate invoice. Please try again.';
      if (error.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const parsed = JSON.parse(text);
          if (parsed?.message) errorMessage = parsed.message;
        } catch (_) {}
      } else if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }
      toast.error(errorMessage,"for the selected User type");
      alert(errorMessage,"for the selected User type");
    }
    setLoading(false);
  };


  const handleDeleteSalesEntry = async (patientfullname) => {
    setLoading(true);
    try {
      const response = await axios.delete(
        `${process.env.REACT_APP_API_BASE_URL}/api/sales/${selectedEntryId}`,
        {userType,},
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Accept': 'application/pdf', // Expect a PDF response
          },
          
        }
      );    
     
      setIsDeleteModalOpen(false);
      toast.success(`Sales Entry ${selectedEntryId}  is deleted Successfully`)
    } catch (error) {
      console.error('Error deleting SalesEntry:', error);
      alert('Failed to Delete SalesEntry. Please try again.');
    }
    setLoading(false);
  };

  // const handleSave = async (entry) => {
  //   try {
  //     await axios.put(`http://localhost:3000/api/sales/${entry.id}`, entry, {
  //       headers: {
  //         'Authorization': `Bearer ${localStorage.getItem('token')}`,
  //       }
  //     });
  //     alert('Entry updated successfully!');
  //     setEditableEntryId(null); // Close edit mode
  //   } catch (error) {
  //     alert('Failed to update entry.');
  //     console.error('Failed to update entry:', error);
  //   }
  // };

  const handleChange = (id, field, value) => {
    setSalesEntries((prevEntries) =>
      prevEntries.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry
      )
    );
  };

//   useEffect(() => {
//     console.log("into useeffect of send email")
//     console.log("params",isModalOpen,selectedEntryForEmail)
//     if (isModalOpen && selectedEntryForEmail) {
//         // Fetch the email content from the backend
//         axios.post('http://localhost:3000/api/sales/sendEmail', selectedEntryForEmail)
//             .then(response => {
//                 setEmailHTML(response.data.html);
//             })
//             .catch(error => {
//                 console.error('Failed to fetch email preview:', error);
//                 setEmailHTML('<p>Failed to load email preview.</p>');
//             });
//     }
// }, [isModalOpen, selectedEntryForEmail]);
const handleExport = () => {
  // console.log("Exporting data:", tableData);
  exportToExcel(buildTableData(), "ExportedData");
};
// Built on click only; computing it every render cost seconds once all rows are loaded.
const buildTableData = () => (Array.isArray(salesEntries) ? salesEntries : []).map((entry) => ({
  'Sales ID': entry.id,
  'Created Date/time':entry?.createdAt,
  'Patient Name': entry.PatientFullName,
  'Mobile Number': entry.PatientMobileNumber,
  'Address': entry.PatientAddress,
  'Details':entry.Details,
  'Patient Gender':entry.PatientGender,
  'Patient DOB':formatDate(entry.PatientDateOfBirth),
  'Email': entry.PatientEmailID,
  'Primary Physician':entry.ReferringConsultantName_PrimaryPhysician,
  'Primary Physician Mobile Number':entry.PrimaryPhysicianMobileNumber,
  'Alternative Physician Email Id':entry.PrimaryPhysicianEmailId,
  'Hospital/Clinic Name':entry.HospitalClinicName,
  'Hospital/Clinical Email Id':entry.HospitalorClinicalEmailId,
  'City':entry.City,
  'Clinical Details of Patient/Patient History Provisional Diagnosis':entry.ClinicalDetailsofPatient_PatientHistory_PriviousDiagonosis,
  'Test Details':entry.tests
  ? entry.tests
          .map((test) => {
            let s = `Test: ${test.test || 'N/A'}, Sample: ${test.sample || 'N/A'}`;
            if (test.sampleReceivedDate) s += `, Received: ${formatDate(test.sampleReceivedDate)}`;
            if (test.reportUploadedAt) s += `, Report Sent: ${formatDate(test.reportUploadedAt)}`;
            return s;
          })
          .join('; ')
      : 'No tests available',
  'Sample Sent':entry.SampleSent,    
  'pick-up-address':entry.PickUpAdress,
  'Sample Collection Date and Time':formatDate(entry.SampleCollectionDate),
  'Form Filled By':entry.FormFilledBy,
  'Name of Form Filler':entry.FormFilledBy_Name,
  "Invoice No.": entry.Invoice || "",
  'Amount': entry.metadata?.billingCode?.finalAmount || entry.Amount || "",
  'Transaction ID': entry.Transaction_ID,
  'Refund Amount':entry.RefundDetails?.RefundAmount,
  'Refund Date':entry.RefundDetails?.RefundDate,
  'Refund TransactionID':entry.RefundDetails?.RefundTransactionID,
  'AIMS Charges (₹)':entry.totalAimsCharge,
  'Pick Up City':entry.PickUpCity,
  'Contact Person Name':entry.ContactPersonName,
  'Contact Person Number':entry.ContactPersonNumber,
  'Pick Up Date':formatDate(entry.PickUpdate),
  'Status': entry.TransactionStatus,
  'Payment Type': entry.PaymentMethod,
  'Payment Date': formatDate(entry.PaymentDate),
  'Payment Status':entry.PaymentStatus,
  'Payment Amount':entry.PaymentAmount,
  'Phelobotomist':entry.Phelobotomist,
  'Phlebotomist Name':entry.PhelobotomistName, 
  'Sales Person':entry.SalesPerson
  
 
}));


  return (
    <div className="sales-details-container">
      <ToastContainer position="bottom-right" autoClose={5000} />

      {loading ? (
  <RecordsLoader
    title="Loading sales details"
    description="Getting your latest records ready..."
  />
):(
  <>
  {/* --- Pagination / Filters Toolbar --- */}
<div className="pagination-toolbar">
  <h2 className="sales-toolbar-title">Sales Details</h2>
  <button
    onClick={() => displayPage > 1 && goToPage(displayPage - 1)}
    disabled={loading || displayPage <= 1}
  >
    ◀
  </button>

  <span>
    Page {displayPage} / {displayTotalPages} {displayTotal ? `(${displayTotal} total)` : ""}
  </span>
  {!everythingLoaded && total > 0 && (
    <RecordsLoader compact title="Loading all records…" />
  )}

  <button
    onClick={() => displayPage < displayTotalPages && goToPage(displayPage + 1)}
    disabled={loading || displayPage >= displayTotalPages}
  >
    ▶
  </button>

  <label style={{ marginLeft: 10 }}>Page size:</label>
  <select
    value={limit}
    onChange={(e) => handlePageSizeChange(String(e.target.value))}
    disabled={loading}
  >
    <option value={50}>50</option>
    <option value={100}>100</option>
    {/* <option value={200}>200</option> */}
    <option value={500}>500</option>
    {/* <option value={1000}>1000</option>
    <option value={2000}>2000</option> */}
    {/* <option value="unlimited">All</option> */}
  </select>

  {/* Optional: server-side fromDate filter */}
  <label style={{ marginLeft: 10 }}>From date:</label>
  <input
    type="date"
    value={fromDate}
    min={salesAccessMinDate || undefined}
    onChange={(e) => {
      const val = e.target.value;
      if (salesAccessMinDate && val && val < salesAccessMinDate) return;
      setFromDate(val);
      fetchData({ page: 1, fromDate: val });
    }}
    disabled={loading}
    title={salesAccessMinDate ? `Minimum date: ${salesAccessMinDate}` : undefined}
  />

  <button
    onClick={() => fetchData({ page: 1, limit: '50' })}
    disabled={loading}
  >   Refresh 
    <FontAwesomeIcon icon={faSyncAlt} spin={loading} style={{ marginLeft: "8px" }}/>
  </button>

  <div className="sales-toolbar-actions">
    <input
      type="text"
      id="searchInput"
      aria-label="Search by sales ID, patient name, patient phone, patient address, patient email, primary physician, or hospital/clinic"
      placeholder="Search: ID, patient, phone, address, email, doctor, hospital"
      title="Search by sales ID, patient name, patient phone, patient address, patient email, primary physician, or hospital/clinic"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
    />
    <button type="button" onClick={handleExport} title="Export to Excel">
      <FontAwesomeIcon icon={faFileExcel} />
      Export Excel
    </button>
  </div>

  {error && <span style={{ color: "crimson", marginLeft: 10 }}>{error}</span>}
</div>

      <main className="table" id="sales_table">
        <div className="table-container">
          <div className="table__body">
            <table
              ref={tableRef}
              className="sales-table"
              id="dataTable"
              style={useFixedLayout ? { tableLayout: 'fixed', width: colWidths.reduce((a, b) => a + b, 0) } : undefined}
            >
              {useFixedLayout && (
                <colgroup>
                  {colWidths.map((w, i) => <col key={i} style={{ width: w }} />)}
                </colgroup>
              )}
              <thead>
                <tr>
                  <th>Sales ID</th>
                  <th>Created Date & Time</th>
                  <th>Patient Name</th>
                  <th>Number</th>
                  <th style={{ minWidth: '600px', maxWidth: '600px' }}>Address</th>
                  <th>Details</th>
                  <th>User ID</th>
                  <th>Patient Gender</th>
                  <th>Age</th>
                  <th>Patient DOB</th>
                  <th>Patient Email</th>
                  <th>Hospital Id</th>
                  <th>Primary Physician</th>
                  <th>Primary Physician Mobile Number</th>
                  <th>Primary Physician Email Id</th>
                  <th>Refering doctor Name(Alternative Physician)</th>
                  <th>Alternative Physician Mobile No.</th>
                  <th>Alternative Physician Email Id</th>
                  <th>Hospital/Clinic Name</th>
                  <th>Hospital/Clinical Email Id</th>
                  <th>City</th>
                  <th class="pick-up-address">Clinical Details of Patient/Patient History, Provisional Diagnosis</th>
                  <th className="test-details-column">Test Details</th>
                  <th>Sample Sent</th>
                  <th>Sample Collection Date and Time</th>
                  <th>Form Filled By</th>
                  <th>Name of Form Filler</th>
                  {/* <th>Sample Received Status</th> */}
                  {/* <th>Received by</th> */}
                  <th>Amount (₹)</th>
                  <th>Transaction ID</th>
                  {(userRole==="admin")&&<th>Refund (₹)</th>}
                  <th>Phelobotomist</th>
                  <th>Phlebotomist Name</th>
                  <th class="pick-up-address">Pick Up Address</th>
                  <th>Pick Up City</th>
                  <th>Pick Up City Pincode</th>
                  <th>Contact Person Name</th>
                  <th>Contact Person Number</th>
                  <th>Pick Up Date</th>
                  
                  {(userRole==="admin" 
                    ||userRole==="sales_rep" ||userRole==="Super_Admin" ||userRole==="regional_sales_head") && <th>Payment Details</th>}   
                     {(userRole==="admin"||userRole==="sales_rep" ||userRole==="Super_Admin" ||userRole==="regional_sales_head")&&<th>Sales Person</th>}   
                  <th>Transaction Status</th>
                 <th>Email Status</th>
                {!['sales_viewer'].includes(userRole) && <th>Actions</th>}
                </tr>
              </thead>
              <tbody>
                {/* {console.log("filteredData2134",filteredData)} */}
            {renderedData.map((entry, index) => (
              <React.Fragment key={entry.id}>
              {hasMoreRows && index === triggerIndex && (
                <tr ref={sentinelRef}>
                  <td colSpan={50} style={{ height: 1, padding: 0, border: 0 }} />
                </tr>
              )}
              <MemoRow
                key={entry.id}
                deps={[entry, editableEntryId === entry.id, openKebabId === entry.id, savingEntryId !== null, userRole, canSeeDates, canEditSalesEntry, testlist, salesPersons]}
                render={() => (
              <tr key={entry.id} style={openKebabId === entry.id ? { backgroundColor: '#d4f1ec', outline: '2px solid #007f66' } : {}}>
                {editableEntryId === entry.id ? (
                    <>
                    <td>{entry.id}</td>
                    <td>{formatDate(entry.createdAt,{time:true})}</td>

                    <td><textarea value={entry.PatientFullName} onChange={(e) => handleChange(entry.id, 'PatientFullName', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.PatientMobileNumber} onChange={(e) => handleChange(entry.id, 'PatientMobileNumber', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td style={{ minWidth: '600px', maxWidth: '600px' }}><textarea value={entry.PatientAddress} onChange={(e) => handleChange(entry.id, 'PatientAddress', e.target.value)} style={{ width: '100%', minHeight: '60px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.PatientDetails} onChange={(e) => handleChange(entry.id, 'PatientDetails', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td>{entry.UserID}</td>
                    <td><textarea value={entry.PatientGender} onChange={(e) => handleChange(entry.id, 'PatientGender', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><input type="number" value={entry.PatientAge} onChange={(e) => handleChange(entry.id, 'PatientAge', e.target.value)} /></td>
                    <td><input type="date" value={entry.PatientDateOfBirth} onChange={(e) => handleChange(entry.id, 'PatientDateOfBirth', e.target.value)} /></td>
                    <td><textarea value={entry.PatientEmailID} onChange={(e) => handleChange(entry.id, 'PatientEmailID', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.PatientHospitalID} onChange={(e) => handleChange(entry.id, 'PatientHospitalID', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.ReferringConsultantName_PrimaryPhysician} onChange={(e) => handleChange(entry.id, 'ReferringConsultantName_PrimaryPhysician', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.PrimaryPhysicianMobileNumber} onChange={(e) => handleChange(entry.id, 'PrimaryPhysicianMobileNumber', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.PrimaryPhysicianEmailId} onChange={(e) => handleChange(entry.id, 'PrimaryPhysicianEmailId', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.ReferringDoctorName_AlternatePhysician} onChange={(e) => handleChange(entry.id, 'ReferringDoctorName_AlternatePhysician', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.AlternativePhysicianMobileNo} onChange={(e) => handleChange(entry.id, 'AlternativePhysicianMobileNo', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.AlternativePhysicianEmailId} onChange={(e) => handleChange(entry.id, 'AlternativePhysicianEmailId', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.HospitalClinicName} onChange={(e) => handleChange(entry.id, 'HospitalClinicName', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.HospitalorClinicalEmailId} onChange={(e) => handleChange(entry.id, 'HospitalorClinicalEmailId', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.City} onChange={(e) => handleChange(entry.id, 'City', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td class="pick-up-address"><textarea value={entry.ClinicalDetailsofPatient_PatientHistory_PriviousDiagonosis} onChange={(e) => handleChange(entry.id, 'ClinicalDetailsofPatient_PatientHistory_PriviousDiagonosis', e.target.value)} style={{ width: '100%', minHeight: '60px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    {/* <td><input type="text" value={entry.tests ? formatTests(entry.tests) : "No tests available"} onChange={(e) => handleChange(entry.id, 'tests', e.target.value)} /></td> */}
                        <td>
                          {/* {console.log("entrytest",entry.tests)} */}
                           {entry.tests && entry.tests.map((test, index) => (
                            <div key={index}>
                              <select
                                type="text"
                                value={test.test}
                                onChange={(e) => handleTestChange(entry.id, index, 'test', e.target.value)}
                                style={{ display: 'inline-block', cursor: 'pointer',width:"250px"}}

                              >
                                <option value="">Select Test </option>
                              {testlist.map((test) => (
                            <option key={test.id} value={test.TestName}>
                              {test.TestName}
                            </option>
                              ))}


                                </select>
                              <select
                                type="text"
                                value={test.sample}
                                onChange={(e) => handleTestChange(entry.id, index, 'sample', e.target.value)}
                                style={{ display: 'inline-block', cursor: 'pointer',width:"150px"}}
                              >
                               <option value="">Select Sample</option>
                              <option value="Serum">Serum</option>
                              <option value="CSF">CSF</option>
                              <option value="Both Serum & CSF">Both Serum & CSF</option>
                              </select>
                              <button
                                      type="button"
                                      onClick={() => handleRemoveTest(entry.id,test.id, index)}
                                      style={{
                                        display: 'inline-block',
                                        cursor: 'pointer',
                                        padding: '5px',
                                        backgroundColor: 'red',
                                        color: 'white'
                                      }}
                                    >
                                      Remove
                                    </button>
                               </div>
                          ))}
                          <button type="button" onClick={() => handleAddTest(entry.id)}>Add Test</button>
                        </td>
                     <td>
                     <select
                                type="text"
                                value={entry.SampleSent}
                                onChange={(e) => handleChange(entry.id,'SampleSent', e.target.value)}
                                style={{ display: 'inline-block', cursor: 'pointer',width:"150px"}}
                              >
                               <option value="">Select Sample</option>
                              <option value="Serum">Serum</option>
                              <option value="CSF">CSF</option>
                              <option value="Both Serum & CSF">Both Serum & CSF</option>
                              </select>
                      
                      </td>   
  
                    <td><input type="date" value={entry.SampleCollectionDate} onChange={(e) => handleChange(entry.id, 'SampleCollectionDate', e.target.value)} /></td>
                    <td><textarea value={entry.FormFilledBy} onChange={(e) => handleChange(entry.id, 'FormFilledBy', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.FormFilledBy_Name} onChange={(e) => handleChange(entry.id, 'NameOfFormFiller', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    {/* <td><input type="text" value={entry.SampleReceivedStatus} onChange={(e) => handleChange(entry.id, 'SampleReceivedStatus', e.target.value)} /></td> */}
                    {/* <td><input type="text" value={entry.ReceivedBy} onChange={(e) => handleChange(entry.id, 'ReceivedBy', e.target.value)} /></td> */}
                    <td><input type="number" value={entry.metadata?.billingCode?.finalAmount || entry.Amount} readOnly title="Set via Billing Code" /></td>
                    <td><input type="number" value={entry.Transaction_ID} onChange={(e) => handleChange(entry.id, 'Transaction_ID', e.target.value)} /></td>
                    {(userRole==="admin")&&<td><input type="number" value={entry?.RefundDetails?.RefundAmount} /></td>}
                    <td><input type="number" value={entry.Phelobotomist} onChange={(e)=>handleChange(entry.id,'Phelobotomist',e.target.value)}/></td>
                    <td><textarea value={entry.PhelobotomistName} onChange={(e)=>handleChange(entry.id,'PhelobotomistName',e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }}/></td>

                    <td class="pick-up-address"><textarea value={entry.PickUpAdress} onChange={(e) => handleChange(entry.id, 'PickUpAdress', e.target.value)} style={{ width: '100%', minHeight: '60px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.PickUpCity} onChange={(e) => handleChange(entry.id, 'PickUpCity', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.PickUpCityPinCode} onChange={(e) => handleChange(entry.id, 'PickUpCityPinCode', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.ContactPersonName} onChange={(e) => handleChange(entry.id, 'ContactPersonName', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><textarea value={entry.ContactPersonNumber} onChange={(e) => handleChange(entry.id, 'ContactPersonNumber', e.target.value)} style={{ width: '100%', minHeight: '38px', resize: 'vertical', fontSize: '13px', padding: '4px' }} /></td>
                    <td><input type="date" value={entry.PickUpdate} onChange={(e) => handleChange(entry.id, 'PickUpdate', e.target.value)} /></td>
                   {["admin", "sales_rep", "Super_Admin", "regional_sales_head"].includes(userRole) && (
                      <td>
                        <div className="payment-details-cell">
                          <button
                            onClick={() => handleOpenPaymentModal(entry)}
                            className={entry.PaymentStatus === "Received" ? "received-button" : "pending-button"}
                          >
                            {entry.PaymentStatus === "Received" ? "Received" : "Pending"}
                          </button>
                          {entry?.Invoice && <span className="invoice-number">{entry.Invoice}</span>}
                        </div>
                      </td>
                    )}
                    {(userRole==="admin" || userRole ==="sales_rep"||userRole==="Super_Admin" ||userRole==="regional_sales_head") &&
                    <td>
                     <select
                                type="text"
                                value={entry.SalesPerson}
                                onChange={(e) => handleChange(entry.id,'SalesPerson', e.target.value)}
                                style={{ display: 'inline-block', cursor: 'pointer',width:"150px"}}
                              >
                               <option value="">Select</option>
                              {salesPersons.filter(user => user.name).map(user => (
                                <option key={user.UserID} value={user.name}>{user.name}</option>
                              ))}
                              <option value="Others">Others</option>
                              
                              </select>
                      
                      </td>  }
                    
                    <td>
                      
                      <button
                        style={{ margin: "5px" }}
                        onClick={() => handleSave(entry, 'Draft')}
                        disabled={savingEntryId !== null}
                      >
                        Move to Draft
                      </button>
                      <button
                        style={{ margin: "5px" }}
                        onClick={() => handleSave(entry, 'Approved')}
                        disabled={savingEntryId !== null}
                      >
                        Approve
                      </button>
                    </td>
                    {/* {userRole==="admin"&& <td>
                   <button style={{ margin: "5px" }} onClick={() => handleOpenModal(entry)}>Send Email</button>
                   <button onClick={() => generateTRFDocument(entry)}>Generate TRF</button>
                    </td>}
                    <td >
                  <span className={entry.EmailSent ? "email-Sent" : "email-Pending"}>{entry.EmailSent?"Sent":"Pending"}</span>

                  </td>
                  {(userRole==="admin")&&<td>
                                  <button
                                    onClick={() => handleInvoiceModal(entry)}
                                    disabled={loading}
                                    style={{ margin: "5px" }}
                                  >
                                    Generate Invoice
                                  </button>
                  </td>}
                    <td><input type="text" value={entry.SalesPerson} onChange={(e) => handleChange(entry.id, 'SalesPerson', e.target.value)} /></td> */}

                    
                    </>
      ) : (
        <>
        <td>{entry.id}</td>
        <td>{entry.createdAt===""?"-":formatDate(entry.createdAt,{time:true} )}</td>
          <td>{entry.PatientFullName}</td>
          <td>{entry.PatientMobileNumber}</td>
          <td style={{ minWidth: '600px', maxWidth: '600px', whiteSpace: 'normal', wordBreak: 'break-word' }}>{entry.PatientAddress}</td>
          <td>{entry.PatientDetails}</td>
          <td>{entry.UserID}</td>
          <td>{entry.PatientGender}</td>
          <td>{entry.PatientAge}</td>
          <td>{entry.PatientDateOfBirth==="Invalid date"?"-":formatDate(entry.PatientDateOfBirth)}</td>
          <td>{entry.PatientEmailID}</td>
          <td>{entry.PatientHospitalID}</td>
          <td>{entry.ReferringConsultantName_PrimaryPhysician}</td>
          <td>{entry.PrimaryPhysicianMobileNumber}</td>
          <td>{entry.PrimaryPhysicianEmailId}</td>
          <td>{entry.ReferringDoctorName_AlternatePhysician}</td>
          <td>{entry.AlternativePhysicianMobileNo}</td>
          <td>{entry.AlternativePhysicianEmailId}</td>
          <td>{entry.HospitalClinicName}</td>
          <td>{entry.HospitalorClinicalEmailId}</td>
          <td>{entry.City}</td>
          <td class="pick-up-address">{entry.ClinicalDetailsofPatient_PatientHistory_PriviousDiagonosis}</td>
          <td dangerouslySetInnerHTML={{ __html: entry.tests ? formatTests(entry.tests) : "No tests available" }} />
          <td>{entry.SampleSent}</td>
          <td>{formatDate(entry.SampleCollectionDate)}</td>
          <td>{entry.FormFilledBy}</td>
          <td>{entry.FormFilledBy_Name}</td>
          {/* <td>{entry.SampleReceivedStatus}</td> */}
          {/* <td>{entry.ReceivedBy}</td> */}
          <td>{entry.metadata?.billingCode?.finalAmount || entry.Amount || ""}</td>
          <td>{entry.Transaction_ID}</td>
        

          {(userRole==="admin")&& <td>
            <button onClick={() => handleOpenRefundModal(entry)}
              className={entry?.RefundDetails?.RefundAmount  ? "refund-button" : "refund-button"}>
              {entry.RefundDetails?.RefundAmount?(entry.RefundDetails?.RefundAmount):"-"}
            </button>
          </td>}

          <td>{entry.Phelobotomist}</td>
          <td>{entry.PhelobotomistName}</td>
          <td class="pick-up-address">{entry.PickUpAdress}</td>
          <td>{entry.PickUpCity}</td>
          <td>{entry.PickUpCityPinCode}</td>
          
          <td>{entry.ContactPersonName}</td>
          <td>{entry.ContactPersonNumber}</td>
          <td>{formatDate(entry.PickUpdate)}</td>
         {(userRole==="admin" || userRole ==="sales_rep"||userRole==="Super_Admin" ||userRole==="regional_sales_head")&& <td>
            <div className="payment-details-cell">
              <button onClick={() => handleOpenPaymentModal(entry)}
                className={entry.PaymentStatus === "Received" ? "received-button" : "pending-button"}>
                {entry.PaymentStatus === "Received" ? "Received" : "Pending"}
              </button>
              {entry?.Invoice && <span className="invoice-number">{entry.Invoice}</span>}
            </div>
          </td>}
          {(userRole==="admin"|| userRole==="sales_rep"||userRole==="Super_Admin" ||userRole==="regional_sales_head")&&<td>{entry.SalesPerson}</td>}

          <td>
            {canEditSalesEntry ? (
              entry.TransactionStatus === "Approved" ? (
                userRole === "admin" ? (
                  <button
                    style={{ margin: "5px", backgroundColor: "mediumBlue" }}
                    onClick={() => handleEdit(entry.id)}
                    disabled={savingEntryId !== null}
                  >
                    Approved
                  </button>
                ) : "Approved"
              ) : (
                <button
                  style={{ margin: "5px", backgroundColor: "yellowgreen" }}
                  onClick={() => handleEdit(entry.id)}
                  disabled={savingEntryId !== null}
                >
                  Draft
                </button>
              )
            ) : (entry.TransactionStatus || "-")}
          </td>
        
          
        </>
      )}
      <td className="email-status-cell">
            {["doctor", "patient"].map((emailType) => {
              const latestEmailLog = Array.isArray(entry.emaillogs)
                ? entry.emaillogs.find((log) => log.emailType === emailType)
                : null;

              return (
                <div className="email-status-row" key={emailType}>
                  <span className="email-recipient-label">
                    {emailType === "doctor" ? "Doctor" : "Patient"}
                  </span>
                  {latestEmailLog?.sentAt && (
                    <time className="email-recipient-time" dateTime={latestEmailLog.sentAt}>
                      {formatDate(latestEmailLog.sentAt, { time: true })}
                    </time>
                  )}
                  {!latestEmailLog?.sentAt && (
                    <span className="email-recipient-pending">
                      {latestEmailLog ? "Sent" : "Pending"}
                    </span>
                  )}
                </div>
              );
            })}
      </td>
  
        {!['sales_viewer'].includes(userRole) && (
          <td>
            <button
              className="kebab-btn"
              onClick={(e) => {
                e.stopPropagation();
                if (openKebabId === entry.id) { setOpenKebabId(null); return; }
                const rect = e.currentTarget.getBoundingClientRect();
                setKebabPos({ top: rect.bottom + 4, right: window.innerWidth - rect.right });
                setOpenKebabId(entry.id);
              }}
            >⋮</button>
          </td>
        )}
     
      

              </tr>
                )}
              />
              </React.Fragment>
            ))}
              </tbody>
            </table>
          </div>
        </div>
      </main>
      </>
)}

      {/* Kebab dropdown — rendered outside the table so overflow:hidden never clips it */}
      {openKebabId && (
        <div className="kebab-menu" style={{ top: kebabPos.top, right: kebabPos.right }} onClick={(e) => e.stopPropagation()}>
          {filteredData.filter(e => e.id === openKebabId).map(entry => (
            <React.Fragment key={entry.id}>
              <button className="kebab-item" onClick={() => { setOpenKebabId(null); handleOpenModal(entry); }}>Send Pick Up Email</button>
              <button className="kebab-item" onClick={() => { setOpenKebabId(null); generateTRFDocument(entry); }}>Generate TRF</button>
              {(userRole==="admin"||userRole==="Super_Admin") && <button className="kebab-item" onClick={() => { setOpenKebabId(null); handleInvoiceModal(entry); }}>Generate Invoice</button>}
              <button className="kebab-item" onClick={() => { setOpenKebabId(null); handleBillingCodeModal(entry); }}>Billing Code</button>

              <button className="kebab-item danger" onClick={() => { setOpenKebabId(null); handleDeleteModal(entry); }} disabled={loading || entry.TransactionStatus==="Approved"}>Delete</button>
            </React.Fragment>
          ))}
        </div>
      )}

      {isModalOpen && (
       
        <div className= "modal" style={{ 
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 1000
        }}>
          <div className="modal-content" style={{ 
          // width: '90vw',
          maxWidth:'900px',
          maxHeight: '80%',
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '8px',
          overflowY: 'auto',
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)'
        }}>
            <h2 style={{marginTop:"0px"}}>Email Preview</h2>
            <hr></hr>
            <div dangerouslySetInnerHTML={{ __html: emailHTML }} />
            {/* <p>Name: {selectedEntryForEmail.PatientName}</p>
            <p>Patient Details: {selectedEntryForEmail.PatientDetails}</p> */}
             <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'space-between' }}>
            <button onClick={sendEmail} style={{ padding: '5px', margin: '2px', cursor: loading?"not-allowed":"pointer", opacity:loading?0.6:1 }} disabled={loading}>
            {loading?"Sending Email...": "Confirm & Send"} 
            </button>
            <button onClick={() => setIsModalOpen(false)} style={{ padding: '5px', margin: '2px', backgroundColor:'red' , cursor: loading?"not-allowed":"pointer", opacity:loading?0.6:1 }} disabled={loading}>
              Cancel</button>
              </div>
          </div>
        </div>
      )}

      {isPaymentModalOpen && (
        <UpdatePaymentModal
          entry={selectedEntryForPayment}
          onClose={() => setIsPaymentModalOpen(false)}
          onUpdate={updatePaymentDetails}
          isReadOnly={selectedEntryForPayment.PaymentStatus === 'Received' && userRole !== 'admin' && userRole !== 'Super_Admin'}
          userRole={userRole}
          />
      )}
       {isRefundModalOpen && (
        <UpdateRefundModal
          entry={SelectedEntryForRefund}
          onClose={() => setIsRefundModalOpen(false)}
          onUpdate={updateRefundDetails}
          // isReadOnly={!!SelectedEntryForRefund?.RefundDetails?.RefundAmount}
          isReadOnly={false}
          />
      )}

       {/* Modal for invoice Generation */}
       {isInvoiceModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h3>Select Sales Type</h3>
            <select value={userType} onChange={(e) => setUserType(e.target.value)}>
            {userTypes.map((type, index) => (
                <option key={index} value={type}>
                  {type}
                </option>
              ))}
            </select>
            <div className="modal-actions">
              <button onClick={handleGenerateInvoice} disabled={!userType || loading}>
                Generate Invoice
              </button>
              <button onClick={() => setIsInvoiceModalOpen(false)}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
       {/* Modal for Billing Code Generation */} 
      {isBillingCodeModalOpen && (
  <div className="modal">
    <div className="modal-content">
      <h3>Select Sales Type</h3>

      {/* Sales Type */}
      <select value={userType} onChange={handleUserTypeChange} disabled={billingAmountsLoading}>
        <option value="">Select Sales Type</option>
        {userTypes.filter((type) => type !== 'Select').map((type, index) => (
          <option key={index} value={type}>
            {type}
          </option>
        ))}
      </select>
      {billingAmountsLoading && <p>Loading amounts...</p>}

      {/* Amount */}
      <div className="form-group">
        <label>Amount</label>
        <input type="number" value={amount} readOnly />
      </div>

      {/* Discount */}
      <div className="form-group">
        <label>Discount</label>
        <input
          type="number"
          value={discount}
          onChange={(e) => setDiscount(e.target.value)}
        />
      </div>

      {/* Additional Charges */}
      <div className="form-group">
        <label>Additional Charges</label>
        <input
          type="number"
          value={additionalCharge}
          onChange={(e) => setAdditionalCharge(e.target.value)}
        />
      </div>

      {/* Final Amount */}
      <div className="form-group">
        <label>Final Amount</label>
        <input type="number" value={finalAmount} readOnly />
      </div>

      <div className="modal-actions">
        <button
          onClick={handleGenerateBillingCode}
          disabled={!userType || loading || billingAmountsLoading}
        >
          Generate Billing Code
        </button>

        <button onClick={() => setIsBillingCodeModalOpen(false)}>
          Cancel
        </button>
      </div>
    </div>
  </div>
)}

      {/* Modal for delete sales Entry */}
      {isDeleteModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h3>Confirm Delete Sales Entry</h3>
            <p>Are you sure you want to delete Sales Entry ID {selectedEntryId}? All associated tests will also be permanently removed.</p>
         {/* delete code */}
             <div className="modal-actions">
              <button onClick={handleDeleteSalesEntry} disabled={!selectedEntryId || loading}>
                Delete
              </button>
              <button onClick={() => setIsDeleteModalOpen(false)}>
                Cancel
              </button>
            </div> 
          </div>
        </div>
      )}
    </div>
  );
};

export default SalesDetailsPage;
